/**
 * Ayuda — Comercial → Costos
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_COM_COSTS_ITEM = {
  id: 'costs',
  screenId: 'adm-com-costs',
  label: 'Costos',
  description: 'Costo de los artículos según el último precio de compra.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá ves los artículos que ya compraste, con el costo tomado del último precio de compra. Tocá un artículo para ver las últimas compras, el proveedor, el comprobante y el precio promedio.',
      },
      {
        title: 'Paso 1 — Ver el listado',
        intro: 'La lista muestra solo artículos que tienen al menos una factura de compra.',
        bullets: [
          'Columnas: Código, Descripción, Costo (último precio de compra y moneda), Fecha última compra.',
          'La lista está paginada: podés cambiar de página y cuántos artículos ver.',
          'Podés exportar la lista con el ícono de descarga.',
        ],
      },
      {
        title: 'Paso 2 — Filtrar',
        bullets: [
          'Buscar: escribí al menos 3 letras del código o la descripción. Si borrás el texto, vuelve la lista completa.',
          'Grupo de artículos: dejá «Todos» o elegí un grupo para ver solo esos productos.',
          'Proveedor: escribí el nombre y elegilo de la lista. El costo y la fecha pasan a ser los de la última compra a ese proveedor.',
        ],
      },
      {
        title: 'Paso 3 — Ver el historial de un artículo',
        intro: 'Tocá una fila para abrir la ventana de detalle.',
        bullets: [
          'Arriba aparece el artículo, su código y el precio promedio de las últimas compras (hasta 10).',
          'Abajo, la lista de esas compras: Fecha, Proveedor, Tipo de factura, Número y Precio.',
          'Si filtraste por proveedor, el historial y el promedio son solo de ese proveedor.',
          'Las notas de crédito no entran en el costo ni en el historial.',
        ],
      },
    ],
  },
}
